// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import { userPendingInvitations } from "../../../../store/user/userSelectors";

import {
  acceptCompanyInvitation,
  declineCompanyInvitation,
} from "../../../../store/user/userActions";
import { acceptedCompanyInvitation } from "../../../../store/companies/companiesSlice";

import { useMediaQuery } from "../../../../hooks/useMediaQuery";

import { CardLink } from "../../../UI/CardLink/CardLink";
import { PopOver } from "../../../UI/PopOver/PopOver";

import { Badge } from "../../../../../web-utils/src/UI/Component/React/V1/Badge/Badge";
import { Button } from "../../../../../web-utils/src/UI/Component/React/V1/Button/Button";

import styles from "../Navigation.module.css";
import button from "../../../UI/Button/Button.module.css";

export const UserInvitations = () => {
  const pendingInvitations = useSelector(userPendingInvitations, shallowEqual);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const dispatch = useDispatch();

  const handleInvitation = async (invitation, action) => {
    const data = {
      company_uuid: invitation.company_uuid,
      member_email: invitation.member_email,
      token: invitation.token,
    };
    if (action === "accept") {
      const response = await dispatch(acceptCompanyInvitation(data));
      if (acceptCompanyInvitation.fulfilled.match(response)) {
        dispatch(acceptedCompanyInvitation(response.payload));
      }
    } else if (action === "decline") {
      await dispatch(declineCompanyInvitation(data));
    }
  };

  return (
    <PopOver
      color=""
      iconType="notification"
      fill="var(--color-light)"
      stroke="none"
      hoverEffect={true}
      classname={button.btnNavigation}
      buttonText={
        <>
          {isMobile ? "Notifications" : null}
          {!pendingInvitations?.length ? null : (
            <span className={styles.alert}>
              <Badge
                status={pendingInvitations?.length}
                variant="primary"
                round
              />
            </span>
          )}
        </>
      }
    >
      <div className={styles.navItemContainer}>
        <div className={styles.padding}>
          <h3 className={styles.borderBottom}>Join a company</h3>
          {pendingInvitations?.length ? (
            <div>
              {pendingInvitations?.map((el, i) => (
                <CardLink key={i} view={false} grid={false}>
                  <div className={styles.card}>
                    <p className={styles.text}>
                      {el?.company?.company_name} invited you.
                    </p>

                    <Button
                      onClick={() => handleInvitation(el, "accept")}
                      iconType="isSuccess"
                      color="success"
                      stroke={`var(--color-success)`}
                      round
                    />
                    <Button
                      onClick={() => handleInvitation(el, "decline")}
                      iconType="close"
                      color="error"
                      stroke={`var(--color-error)`}
                      round
                    />
                  </div>
                </CardLink>
              ))}
            </div>
          ) : (
            <div className={styles.item}>
              <p>No invitations found</p>
            </div>
          )}
        </div>
      </div>
    </PopOver>
  );
};
